import React from "react";
import "./Homepage.css";
import { Typography, Avatar, ListItem, List, Stack } from "@mui/joy";
import DescriptionIcon from "@mui/icons-material/Description";
import EmailIcon from "@mui/icons-material/Email";
import BorderColorIcon from "@mui/icons-material/BorderColor";

const HowTo = () => {
  return (
    <Stack direction={"column"} padding={8} spacing={4}>
      <Stack direction={"column"} spacing={4}>
        <Typography level="h1" sx={{ textAlign: "center" }}>
          Engage with Your Representatives Effortlessly!
        </Typography>
        <Typography level="body-lg" sx={{ textAlign: "center" }}>
          We believe that every voice matters. That's why we've made it easier
          than ever for you to connect with your elected officials. This website
          provides a customizable email template that you can use to express
          your thoughts, concerns, or support on important issues directly to
          your representative.
        </Typography>
      </Stack>
      <List
        component={Stack}
        spacing={0}
        sx={{
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "flex-start",
          alignItems: "stretch",
        }}
      >
        <ListItem sx={{ flexDirection: "column", flex: 1 }}>
          <Avatar color="primary">
            <DescriptionIcon />
          </Avatar>
          <Typography level="title-lg" sx={{ textAlign: "center" }}>
            Choose Your Issue
          </Typography>
          <Typography level="body-md" sx={{ textAlign: "center" }}>
            Select from a list of current bills and legislation that resonate
            with you. View all the details on why it matters.
          </Typography>
        </ListItem>
        <ListItem sx={{ flexDirection: "column", flex: 1 }}>
          <Avatar color="primary">
            <BorderColorIcon />
          </Avatar>
          <Typography level="title-lg" sx={{ textAlign: "center" }}>
            Customize Your Message
          </Typography>
          <Typography level="body-md" sx={{ textAlign: "center" }}>
            Select "Get Started" to find your local representative and use our
            user-friendly email template to craft your message. Personalize it
            to reflect your views and experiences.
          </Typography>
        </ListItem>
        <ListItem sx={{ flexDirection: "column", flex: 1 }}>
          <Avatar color="primary">
            <EmailIcon />
          </Avatar>
          <Typography
            level="title-lg"
            sx={{ textAlign: "center", width: "100%" }}
          >
            Send Your Email
          </Typography>
          <Typography
            level="body-md"
            sx={{ textAlign: "center", width: "100%" }}
          >
            Select "Contact your represenative" to go to their website. All
            representatives have an official website with a contact form that
            you can paste the template into.
          </Typography>
        </ListItem>
      </List>
    </Stack>
  );
};

export default HowTo;
